import { BrowserRouter, Routes, Route } from "react-router-dom";
import News from "pages/support/News";
import Pricing from "pages/Pricing";
import Homepage from "pages/Homepage";
import ContactUs from "pages/support/ContactUs";
import Affiliates from "pages/Affiliates";
import DataCenter from "pages/DataCenter";
import KnowledgeBase from "pages/support/KnowledgeBase";
import PrivacyPolicy from "pages/resources/PrivacyPolicy";
import Refunds from "pages/resources/Refunds";
import SignIn from "pages/authentication/SignIn";
import SignUp from "pages/authentication/SignUp";
import LiveChat from "pages/support/LiveChat";
import Restrictions from "pages/resources/Restrictions";
import TermsOfServices from "pages/resources/TermsOfServices";
import Dashboard from "pages/dashboard";
import ToastNotification from "components/moleculs/ToastNotification";
import NotFound from "pages/NotFound";
import ProxyLayouts from "layouts/ProxyLayouts";
import { useEffect, useRef, useState } from "react";

const App = () => {
    return (
        <BrowserRouter>
            <ToastNotification />
            <Routes>
                <Route index element={<Homepage />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/affiliates" element={<Affiliates />} />
                <Route path="/datacenter" element={<DataCenter />} />
                <Route path="/resources/restrictions" element={<Restrictions />} />
                <Route path="/resources/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/resources/terms-of-service" element={<TermsOfServices />} />
                <Route path="/resources/refunds" element={<Refunds />} />
                <Route path="/support/news" element={<News />} />
                <Route path="/support/contact" element={<ContactUs />} />
                <Route path="/support/knowledge-base" element={<KnowledgeBase />} />
                <Route path="/auth/signin" element={<SignIn />} />
                <Route path="/auth/signup" element={<SignUp />} />
                <Route path="/proxy" element={<ProxyLayouts />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;